import React, { FC } from 'react';
import { Col, FormGroup } from 'react-bootstrap';
import { FormattedMessage } from 'react-intl';
import CheckboxInput from '../../../../../../components/library/inputs/checkbox/CheckboxInput';

interface Props {
  id: string;
  label: string;
  checked: boolean;
  onChange: (checked: boolean) => void;
  size?: number;
}

const CheckboxSetting: FC<Props> = ({ id, label, checked, onChange, size = 12 }: Props) => {
  return (
    <FormGroup className={'form-group property-checkbox'} as={Col} md={size}>
      <CheckboxInput
        id={id}
        label={<FormattedMessage id={label} />}
        value={checked}
        onChange={(e) => onChange(e.target.checked)}
      />
    </FormGroup>
  );
};

export default CheckboxSetting;
